import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=67e214ce&scoped=true"
import script from "./Note.vue?vue&type=script&lang=js"
export * from "./Note.vue?vue&type=script&lang=js"
import style0 from "./Note.vue?vue&type=style&index=0&id=67e214ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e214ce",
  null
  
)

export default component.exports